import React from "react"

import { guid } from "../../../util/Guid"
import ContextMenuAction from "../../common/contextmenu/components/ContextMenuAction"
import { Labels } from "../../../util/Translations"

interface Props {
    executeCallAction: (
        event: React.MouseEvent,
        button: ContextMenu.Button,
    ) => void
    extraClasses?: string
}

const quickEditAction = "QuickEditItemAction"
const quickEditIcon = "QuickEdit"

export default function QuickEditButton({
    executeCallAction,
    extraClasses,
}: Props): JSX.Element {
    const { QuickEdit } = Labels

    const button: ContextMenu.CallButton = {
        uuid: guid(),
        id: quickEditAction,
        caption: QuickEdit,
        icon: quickEditIcon,
        tooltip: "",
        isLoading: false,
        isCustom: false,
        inOptionalMenu: true,
        showCaption: true,
        buttonData: {
            type: "Call",
            actionId: quickEditAction,
        } as ContextMenu.CallButtonData,
    }

    return (
        <ContextMenuAction
            button={button}
            extraClasses={extraClasses}
            executeCallAction={executeCallAction}
            key={button.uuid}
        />
    )
}
